var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrapper"},[_c('div',{class:{ visible: _vm.mapVisible },attrs:{"id":"google-map"}}),(Boolean(this.google) && Boolean(this.map))?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }